import React, { useState } from 'react'
import { css, Global } from '@emotion/core'
import { ThemeProvider } from 'emotion-theming'
import { Match } from '@reach/router'
import Helmet from 'react-helmet'
import Header from '@src/components/Header'
import Footer from '@src/components/Footer'
import Modal from 'react-modal'
import normalize from '../styles/normalize'
import theme from '../styles/theme'
import { ModalProvider, ModalRoot } from '@src/components/modals/ModalController'
import { TranslationProvider } from '@src/components/translation/TranslationContext'
import { AppDataContextProvider } from '@src/components/AppDataContext'
import styled from '@emotion/styled'
import 'modern-normalize/modern-normalize.css'
import { useMatch } from '@reach/router'
import { generatingFor } from '@src/utils/routes'
import Spacer from '@src/components/Spacer'

Modal.setAppElement('#___gatsby')

const StyledLayoutMain = styled.main`
  box-sizing: border-box;
  min-width: 0px;
  flex-grow: 1;
  margin: 0px;
  overflow-y: auto;
  overflow-x: hidden;
`

type PageLayoutProps = {
  children: any
  pageContext: any
}
const PageLayout: React.FC<PageLayoutProps> = ({ children, pageContext }) => {
  const remoteUrl1 = useMatch('/remotelearning')
  const remoteUrl2 = useMatch('/remotelearning_lp')
  const isRemoteLearningPage = remoteUrl1 || remoteUrl2

  const [closureBannerOpen, setclosureBannerOpen] = useState<boolean>(true)
  const closeBanner = () => setclosureBannerOpen(false)
  const showClosureBanner = !isRemoteLearningPage && closureBannerOpen

  generatingFor.locale = pageContext.localeStrings.currentLocale
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://static.classdojo.com/fonts/proxima/proximanova-default-stack.css" />
      </Helmet>
      <Global
        styles={css`
          ${normalize};
          #___gatsby,
          #gatsby-focus-wrapper,
          main,
          html,
          body {
            height: 100%;
          }

          /* modal transitions:  */
          .ReactModal__Content {
            opacity: 0;
            transform: translate(0, -50%);
            transition: transform 300ms ease-out;
          }

          .ReactModal__Content--after-open {
            opacity: 1;
            transform: translate(0, 0);
          }

          .ReactModal__Content--before-close {
            opacity: 0;
            transform: translate(0, -50%);
          }
        `}
      />
      <TranslationProvider localeStrings={pageContext.localeStrings}>
        <ThemeProvider theme={theme}>
          <AppDataContextProvider>
            <ModalProvider>
              {/*<Flex flexDirection="column" height="100%" overflowX="hidden">*/}
              <ModalRoot />

              <StyledLayoutMain id="main-page-container">
                <Header showClosureBanner={showClosureBanner} closeBannerFunction={closeBanner} />
                {showClosureBanner ? <Spacer height="178px" /> : <Spacer height="88px" />}
                {children}
                <Footer />
              </StyledLayoutMain>
              {/*</Flex>*/}
            </ModalProvider>
          </AppDataContextProvider>
        </ThemeProvider>
      </TranslationProvider>
    </>
  )
}

export default PageLayout
